import { detect } from 'detect-browser'

const parser = detect()

export const name = parser.name
export const version = parser.version
export const os = parser.os
export const type = parser.type

export default {
  parser,
  name,
  version,
  os,
  type
}
